import PropTypes from "prop-types";

import ChallengeCountdown from "@/challenges/ChallengeCountdown";
import ChallengeLearnMoreModal from "@/challenges/ChallengeLearnMoreModal/ChallengeLearnMoreModal";
import {
  heading,
  contentWrapper,
  textWrapper,
  imageWrapper,
  imageCss,
} from "./ChallengesTeacherBanner.style";

const propTypes = {
  expirationDate: PropTypes.any,
};

const ChallengesTeacherBanner = ({ expirationDate }) => {
  const month = expirationDate?.toLocaleString("en-GB", { month: "short" });
  const date = expirationDate?.getDate();
  const now = new Date();
  const countdown = Math.floor(
    (expirationDate?.getTime() - now?.getTime()) / (1000 * 3600 * 24),
  );
  const todayMonth = now?.toLocaleString("en-GB", { month: "long" });
  return (
    <div css={contentWrapper}>
      <div css={textWrapper}>
        <h1 css={heading}>
          {todayMonth.charAt(0).toUpperCase() + todayMonth.slice(1)} reading
          challenge
        </h1>
        <ChallengeCountdown month={month} date={date} countdown={countdown} />
        <p>
          Each month, students can read articles that interest them and earn
          tokens for every quiz, Power Words and Guided Highlighting activity
          completed. Students earn a badge when they reach their monthly reading
          goal.
        </p>
        <ChallengeLearnMoreModal />
      </div>
      <div css={imageWrapper}>
        <img css={imageCss} />
      </div>
    </div>
  );
};

ChallengesTeacherBanner.propTypes = propTypes;

export default ChallengesTeacherBanner;
